var _excluded = ["selectedRange", "onChange", "rangeLength", "containerProps"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import addDays from "date-fns/addDays";
import * as React from "react";
import { DateUtils } from "react-day-picker";
import { MODIFIERS } from "./constants";
import DatePicker from "./DatePicker";
import { jsx as ___EmotionJSX } from "@emotion/core";

var FixedDateRangePicker = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FixedDateRangePicker, _React$Component);

  function FixedDateRangePicker() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      highlightedRange: null
    };

    _this.onDayClick = function (day, modifiers) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          allowClear = _this$props.allowClear;
      if (onChange == null || modifiers[MODIFIERS.DISABLED]) return;

      var dayRange = _this._createRange(day);

      if (_this._isSameSelectedRange(day)) {
        if (!allowClear) return;
        onChange(null);

        _this.setState({
          highlightedRange: dayRange
        });

        return;
      }

      onChange(dayRange);

      _this.setState({
        highlightedRange: null
      });
    };

    _this.onDayMouseEnter = function (day, modifiers) {
      if (_this._leaveTimeout) clearTimeout(_this._leaveTimeout);
      if (modifiers[MODIFIERS.DISABLED]) return;

      _this.setState({
        highlightedRange: _this._isSameSelectedRange(day) ? null : _this._createRange(day)
      });
    };

    _this.onDayMouseLeave = function () {
      _this._leaveTimeout = setTimeout(function () {
        return _this.setState({
          highlightedRange: null
        });
      }, 0);
    };

    _this.onMouseLeave = function () {
      _this.setState({
        highlightedRange: null
      });
    };

    _this.onWeekClick = function (_week, days) {
      _this._triggerSelectedStartDayChange(days[0]);

      _this.setState({
        highlightedRange: null
      });
    };

    return _this;
  }

  var _proto = FixedDateRangePicker.prototype;

  _proto._isSameSelectedRange = function _isSameSelectedRange(startDay) {
    var selectedRange = this.props.selectedRange;
    return selectedRange != null && DateUtils.isSameDay(startDay, selectedRange.from);
  };

  _proto._triggerSelectedStartDayChange = function _triggerSelectedStartDayChange(day) {
    var onChange = this.props.onChange;
    if (onChange == null) return;
    onChange(this._createRange(day));
  };

  _proto._createRange = function _createRange(startDay) {
    if (!startDay) return null;
    return {
      from: startDay,
      to: addDays(startDay, this.props.rangeLength - 1)
    };
  };

  _proto.render = function render() {
    var highlightedRange = this.state.highlightedRange; // eslint-disable-next-line @typescript-eslint/no-unused-vars

    var _this$props2 = this.props,
        selectedRange = _this$props2.selectedRange,
        onChange = _this$props2.onChange,
        rangeLength = _this$props2.rangeLength,
        containerProps = _this$props2.containerProps,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    var modifiers = {};
    modifiers[MODIFIERS.IN_RANGE] = [];
    modifiers[MODIFIERS.RANGE_START] = [];
    modifiers[MODIFIERS.RANGE_END] = [];

    if (selectedRange) {
      modifiers[MODIFIERS.IN_RANGE].push(selectedRange);
      modifiers[MODIFIERS.RANGE_START].push(selectedRange.from);
      modifiers[MODIFIERS.RANGE_END].push(selectedRange.to);
    }

    if (highlightedRange) {
      modifiers[MODIFIERS.HIGHLIGHTED] = highlightedRange;
      modifiers[MODIFIERS.IN_RANGE].push(highlightedRange);
      modifiers[MODIFIERS.RANGE_START] = modifiers[MODIFIERS.RANGE_START].filter(function (day) {
        return !DateUtils.isDayInRange(day, highlightedRange);
      });
      modifiers[MODIFIERS.RANGE_START].push(highlightedRange.from);
      modifiers[MODIFIERS.RANGE_END] = modifiers[MODIFIERS.RANGE_END].filter(function (day) {
        return !DateUtils.isDayInRange(day, highlightedRange);
      });
      modifiers[MODIFIERS.RANGE_END].push(highlightedRange.to);
    }

    return ___EmotionJSX(DatePicker, _extends({}, props, {
      selectedDays: selectedRange,
      modifiers: modifiers,
      onDayClick: this.onDayClick,
      onDayMouseEnter: this.onDayMouseEnter,
      onDayMouseLeave: this.onDayMouseLeave,
      onWeekClick: this.onWeekClick,
      containerProps: _extends({}, containerProps, {
        onMouseLeave: this.onMouseLeave
      })
    }));
  };

  return FixedDateRangePicker;
}(React.Component);

FixedDateRangePicker.defaultProps = {
  rangeLength: 7,
  allowClear: false
};
export { FixedDateRangePicker as default };